import Vue from 'vue';
import productTransformer from './../../transformers/product';
import store from './../../store';

const success = ({ data }, resolve) => resolve(productTransformer.fetch(data));

const failed = () => {};


export default id => (
  new Promise((resolve, reject) => {
    const products = store.state.product.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (products.length > 0) {
      return resolve(products[0]);
    }

    return Vue.$http.get(`/products/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/show.js